/**
 * FilterSubmit.jsx
 * Created by Lizzie Salita 8/14/18
 */

import PropTypes from 'prop-types';

const propTypes = {
    filtersChanged: PropTypes.bool,
    applyStagedFilters: PropTypes.func,
    resetFilters: PropTypes.func
};

const FilterSubmit = ({filtersChanged = false, applyStagedFilters = null, resetFilters = null}) => (
    <div className="dashboard-filters__submit-content">
        <button
            className="dashboard-filters__reset"
            aria-label="Reset search"
            onClick={resetFilters}>
                Reset Filters
        </button>
        <button
            className="btn-primary dashboard-filters__submit"
            title="Submit"
            aria-label="Submit"
            disabled={!filtersChanged}
            onClick={applyStagedFilters}>
                Submit
        </button>
    </div>
);

FilterSubmit.propTypes = propTypes;

export default FilterSubmit;
